// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\root.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\root.tsx");
}
// REMIX HMR END

import { Links, Meta, Outlet, Scripts, ScrollRestoration, isRouteErrorResponse, useRouteError, useLocation } from "@remix-run/react";
import stylesheet from "./tailwind.css?url";
import { AppHeader } from "./components/AppHeader";
import { AppFooter } from "./components/AppFooter";
export const links = () => [{
  rel: "stylesheet",
  href: stylesheet
}, {
  rel: "preload",
  href: "/fonts/ClashGrotesk-Variable.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}, {
  rel: "preload",
  href: "/fonts/ClashGrotesk-Bold.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}, {
  rel: "preload",
  href: "/fonts/ClashGrotesk-Semibold.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}];
export function Layout({
  children
}) {
  return <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>;
}
_c = Layout;
export default function App() {
  _s();
  const location = useLocation();

  // Define which pages should use white theme
  // const whiteThemeRoutes = ["/equipment"];
  // const headerTheme = whiteThemeRoutes.some((route) =>
  //   location.pathname.startsWith(route)
  // )
  //   ? "white"
  //   : "dark";

  return <div className="min-h-screen bg-black">
      <AppHeader theme="dark" />

      <main className="pt-16 lg:pt-20">
        <Outlet />
      </main>

      <AppFooter />
    </div>;
}
_s(App, "pkHmaVRPskBaU4tMJuJJpV42k1I=", false, function () {
  return [useLocation];
});
_c2 = App;
export function ErrorBoundary() {
  _s2();
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    return <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">
            {error.status} {error.statusText}
          </h1>
          {error.data && <p className="text-gray-600">{error.data}</p>}
        </div>
      </div>;
  }
  return <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Oops!</h1>
        <p className="text-gray-600">Something went wrong.</p>
      </div>
    </div>;
}
_s2(ErrorBoundary, "oAgjgbJzsRXlB89+MoVumxMQqKM=", false, function () {
  return [useRouteError];
});
_c3 = ErrorBoundary;
var _c, _c2, _c3;
$RefreshReg$(_c, "Layout");
$RefreshReg$(_c2, "App");
$RefreshReg$(_c3, "ErrorBoundary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;